export default "__VITE_ASSET__BvTkzM3M__"